import { create } from "sheetly";
export let text = "svg *{transition:all .3s ease-in-out}";
export const sheet = create(text, import.meta.url);
